module.exports = __webpack_public_path__ + "static/media/sample_3-06.483b9a77.jpg";